import { reactive } from 'vue';
import TimeTicketYearPagedListFilter from '@/components/time-ticket/TimeTicketYearPagedListFilter.vue';
import useSelfService from '../SelfService';
import TimeTicketWeekApiAgency from '@/api/TimeTicketWeekApiAgency';
import TimeTicketWeekApiClient from '@/api/TimeTicketWeekApiClient';
import router from '@/router/index.router';
import BasePagedListFilterService from '../BasePagedListFilterService';

export class TimeTicketYearPagedListFilterService
	extends BasePagedListFilterService<Armado.TimeTicketWeekPagedListParameters, Armado.TimeTicketWeekYear> {
	get quickFilters () {
		return undefined;
	}

	private readonly serviceState = reactive({ year: undefined as Undef<number> });

	protected get api () {
		return useSelfService().self.isAgency()
			? { grid: (listFilter: ITimeTicketWeekPagedListParameters) => TimeTicketWeekApiAgency.listByYearPagedListAsync(this.year, listFilter) }
			: { grid: (listFilter: ITimeTicketWeekPagedListParameters) => TimeTicketWeekApiClient.listByYearPagedListAsync(this.year, listFilter) };
	}

	readonly filterComponent = TimeTicketYearPagedListFilter;

	get year () {
		return +router.currentRoute.value.params.year;
	}

	filter = reactive<Armado.TimeTicketWeekPagedListParameters>({
		...this.commonFilter,
		from: undefined as Undef<string>,
		to: undefined as Undef<string>,
		currentStep: undefined,
		showFlex: false,
		tagIds: [],
		hasTag: false,
		clientCompanyId: undefined as Undef<number>,
		agencyCompanyId: undefined as Undef<number>,
		missionPlaceId: undefined as Undef<number>,
	});
}

const timeTicketYearPagedListFilterServiceSingleton = new TimeTicketYearPagedListFilterService();

export default function usetimeTicketYearPagedListFilterService () {
	return timeTicketYearPagedListFilterServiceSingleton;
}
